import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Projects() {
  return (
    <motion.section 
      id="projects" 
      className="projects"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <h2>Proiecte</h2>
      <p>Aici poți vedea unul dintre proiectele mele recente.</p>
      <Link to="/scheduailer" className="cta-button">
        Vezi ScheduAIler
      </Link>
    </motion.section>
  );
}

export default Projects;